import { render, staticRenderFns } from "./seloLogo.vue?vue&type=template&id=888e84cc&scoped=true"
import script from "./seloLogo.vue?vue&type=script&lang=js"
export * from "./seloLogo.vue?vue&type=script&lang=js"
import style0 from "./seloLogo.vue?vue&type=style&index=0&id=888e84cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888e84cc",
  null
  
)

export default component.exports